import { TokenEntity } from '@interpals/api-web';
import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';
import { ReduxState } from 'redux/root-reducer';
import { changeLocale } from 'utils/i18n';
import { wsDisconnect, wsConnect } from '../actions/websocket';
import { clearUserLocalStorageData } from 'utils/localStorage';

export const clearState = createAsyncThunk('state/clear', (_, { dispatch }) => {
    clearUserLocalStorageData();
    dispatch(wsDisconnect());
});

export const saveToken = createAsyncThunk('login/save-token', (token: TokenEntity) => token);

export const initLoggedInUser = createAsyncThunk('login/init', (token: TokenEntity, { dispatch }) => {
    dispatch(saveToken(token)).then(() => {
        if (token.account?.status === 'active') {
            dispatch(wsConnect());
        }
    });

    changeLocale(token.account?.lang);
});

export const login = createAsyncThunk(
    'login/fetch',
    async (credentials: { username: string; password: string }, { dispatch, rejectWithValue }) => {
        const { username, password } = credentials;

        return api
            .createToken({ username, password })
            .then((payload: TokenEntity) => payload && dispatch(initLoggedInUser(payload)))
            .catch(async (error) => {
                return rejectWithValue(await error.json());
            });
    },
);

export const logout = createAsyncThunk<void, void, { state: ReduxState }>(
    'logout/fetch',
    async (_, { getState, dispatch }) => {
        const { auth } = getState();
        const token = auth.jti;

        // State should be cleared regardless of whether api call is successful (token may have expired)
        dispatch(clearState());

        if (!token) {
            return;
        }

        await api.deleteToken({ id: token });
    },
);
